import React from 'react'
import NotificationTableSkeltonLoader from './NotificationTableSkeltonLoader'

const NotificationCompleteTableSkeleton = (props) => {
    return (
        <div className='gc-notifications py-2.5 px-3 h-[calc(100%-44px)]'>
            <div className='gcn-top'>
                <div className='gcnt-inputs pt-[10px] flex items-center justify-between'>
                    <div className='flex items-center'>
                        <div className='generic-skeleton wid-220 hgt-34 m-bot-0 m-rgt-10'></div>
                        {props?.currentTab === 'email' && <div className='generic-skeleton wid-220 hgt-34 m-bot-0 m-rgt-10'></div>}
                    </div>
                    {/* <div className='generic-skeleton wid-220 hgt-34 m-bot-0'></div> */}
                </div>
            </div>
            <NotificationTableSkeltonLoader />
        </div>
    )
}

export default NotificationCompleteTableSkeleton